import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as Yup from 'yup'

import type { ReactElement } from 'react'
import type { IStateReducer } from '~/types/analytics-context'

import Button from '~/components/Buttons/Button'
import CheckboxInput from '~/components/Inputs/Basic/CheckboxInput'
import TextInput from '~/components/Inputs/ReactHookForm/TextInput'
import Modal from '~/components/Modal'
import { ModalBody, ModalFooter, ModalHeader } from '~/components/Modal/Layout'
import { LOCAL_STORAGE } from '~/const'
import { displayToast } from '~/utils/toast'

interface IFormValue {
  includePeriod?: boolean
  name: string
}

const validationSchema = Yup.object().shape({
  includePeriod: Yup.boolean(),
  name: Yup.string().required(),
})

interface Props {
  currentFilters: IStateReducer['filters']
  isOpen: boolean
  onClose: VoidFunction
}

const NewPresetModal = ({ currentFilters, isOpen, onClose }: Props): ReactElement => {
  /** Local state */

  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    setValue,
  } = useForm<IFormValue>({
    defaultValues: {
      includePeriod: false,
      name: '',
    },
    resolver: yupResolver(validationSchema),
  })

  /** Handlers */

  const handleFormSubmit = (value: IFormValue) => {
    const currentPresets = JSON.parse(localStorage.getItem(LOCAL_STORAGE.FILTERS_PRESETS) || '[]')
    const { endDate, startDate, ...filters } = currentFilters

    localStorage.setItem(
      LOCAL_STORAGE.FILTERS_PRESETS,
      JSON.stringify([
        ...currentPresets,
        {
          filters: {
            ...filters,
            ...(value.includePeriod ? { endDate, startDate } : {}),
          },
          name: value.name,
        },
      ])
    )

    displayToast('Preset created', 'success')
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onCloseModal={onClose}>
      <ModalHeader>Create a new preset</ModalHeader>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <ModalBody>
          <TextInput {...register('name')} error={errors.name?.message} label="Name" name="name" required />
          <br />
          <CheckboxInput
            {...register('includePeriod')}
            label="Include the selected period"
            onChange={(evt) => setValue('includePeriod', evt.target.checked)}
          />
        </ModalBody>
        <ModalFooter>
          <Button ghost onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={isSubmitting} type="submit">
            Create
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}

export default NewPresetModal
